import FeatureToggle from './FeatureToggle'
import withLayout from 'components/layout'

export default withLayout(FeatureToggle)
